import styled, {keyframes} from 'styled-components'
import {Box} from '@viptech/react-components'

const slideUp = keyframes`
  from {
    transform: translate(-50%, 100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
`

const slideDown = keyframes`
  from {
    transform: translate(-50%, 0);
    opacity: 1;
  }
  to {
    transform: translate(-50%, 100%);
    opacity: 0;
  }
`

export const InfiniteScrollLoadingContainer = styled(Box)<{$isVisible: boolean; $bottom?: number}>`
  position: absolute;
  height: 48px;
  border-radius: 12px;
  background-color: white;
  width: 240px;
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  bottom: ${({$bottom}) => $bottom ?? 48}px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  animation: ${({$isVisible}) => ($isVisible ? slideUp : slideDown)} 0.2s ease-out forwards;
`
